const Utils = new (class {
	downloadDataFile(fileName: string, data:Blob) {
		const a = document.createElement("a");
		const url = URL.createObjectURL(data);

		a.href = url;
		a.download = fileName;
		document.body.appendChild(a);
		a.click();
		setTimeout(() => {
			document.body.removeChild(a);
			window.URL.revokeObjectURL(url);
		}, 100);
	}
})()

export default Utils;
